import { render } from "./TownFounding.vue?vue&type=template&id=3b76f18a"
import script from "./TownFounding.vue?vue&type=script&lang=js"
export * from "./TownFounding.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/buildings/house/windowOverlay/TownFounding.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b76f18a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b76f18a', __exports__)) {
    api.reload('3b76f18a', __exports__)
  }
  
  module.hot.accept("./TownFounding.vue?vue&type=template&id=3b76f18a", () => {
    api.rerender('3b76f18a', render)
  })

}


export default __exports__